import React, { useEffect, useMemo, useState } from "react";
import { Typography, makeStyles } from "@material-ui/core";
import Modal from "@/components/Modal";
import MemoedHOC from "@/hoc/MemoedHOC";
import { SimpleStatusChip } from "@/components/commons/StatusChip";
import { useTranslation } from "@/langs/useTranslation";
import { useGroupDeviceState } from "./Provider";
import DeviceControls from "./DeviceControls";
// import { statisticDevicesApi } from "@/apis/apiCollection";
// import ModalLoadingIndicator from "@/components/Modal/ModalLoadingIndicator";

const useStyles = makeStyles(theme => ({
  item: {
    marginBottom: theme.spacing(1),
    display: "flex"
  },
  label: {
    marginRight: theme.spacing(1)
  },
  statusChip: {
    marginRight: theme.spacing(1)
  },
  content: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2),
    background: "#F8F9FC",
    borderRadius: 10,
    marginTop: theme.spacing(2),
    minHeight: 972
  },
  footer: {
    display: "flex",
    justifyContent: "center",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(0.5),

    "& .MuiButton-root": {
      marginRight: theme.spacing(2),
      width: 120
    }
  }
}));

function SendCommandModal({
  getSelectedDevices,
  // selectGroup,
  crossSelect,
  open,
  onClose,
  onSetAlarm,
  onSetSchedule
}) {
  const { t } = useTranslation();
  const classes = useStyles();
  // const [loading, setLoading] = useState(false);
  const [devices, setDevices] = useState([]);
  // const [devicesInfo, setDevicesInfo] = useState({
  //   nubis_free_count: 0,
  //   nubis_pro_count: 0
  // });

  let { currentGroup, currentTag } = useGroupDeviceState();

  const groupedDevices = useMemo(() => {
    const stack = {};
    devices.forEach(device => {
      const status = device.online_offline_status;
      if (status) {
        if (!stack[status]) {
          stack[status] = [];
        }
        stack[status].push(device);
      } else {
        if (!stack["-"]) {
          stack["-"] = [];
        }
        stack["-"].push(device);
      }
    });

    return stack;
  }, [devices]);

  useEffect(() => {
    if (open /* && !selectGroup */) {
      setDevices(getSelectedDevices());
    }
  }, [open]);

  if (!currentGroup) {
    currentGroup = {};
  }

  const checkedGroups = currentGroup.checkedGroups || [];
  const tagId = !crossSelect ? undefined : currentTag?.id;
  const groupIds = useMemo(() => {
    if (!crossSelect) return [];
    return checkedGroups.length > 0
      ? checkedGroups.filter(group => !group.isRoot).map(group => group.id)
      : currentGroup.id && !currentGroup.isRoot
      ? [currentGroup.id]
      : [];
  }, [checkedGroups.length, currentGroup.id, crossSelect]);

  // useEffect(() => {
  //   if (open && selectGroup) {
  //     setLoading(true);
  //     statisticDevicesApi({
  //       group_ids: groupIds.length ? groupIds : undefined,
  //       tag_ids: [tagId]
  //     })
  //       .then(res => {
  //         setDevicesInfo({
  //           nubis_free_count: res.stat.nubis_free_count,
  //           nubis_pro_count: res.stat.nubis_pro_count
  //         });
  //         setDevices(res.stat.devices);
  //       })
  //       .finally(() => {
  //         setLoading(false);
  //       });
  //   }
  // }, [groupIds, tagId, open, selectGroup]);

  // if (loading) {
  //   return <ModalLoadingIndicator />;
  // }

  // if (
  //   devicesInfo.nubis_free_count + devicesInfo.nubis_pro_count > 1 &&
  //   devicesInfo.nubis_free_count > 0
  // ) {
  //   return (
  //     <Modal
  //       showCancel={false}
  //       title={t({ defaultMessage: "温馨提示" })}
  //       open={open}
  //       onConfirm={onClose}
  //       onClose={onClose}
  //     >
  //       {t(
  //         {
  //           defaultMessage:
  //             "选择设备中包含{num}台Nubis Free版本，将无法进行设备命令。"
  //         },
  //         { num: devicesInfo.nubis_free_count }
  //       )}
  //     </Modal>
  //   );
  // }

  return (
    <Modal
      title={t({ defaultMessage: "设备命令" })}
      width={1000}
      open={open}
      onClose={onClose}
      showConfirm={false}
    >
      <div className={classes.item}>
        <Typography variant="body1" className={classes.label}>
          {tagId
            ? t({ defaultMessage: "已选择{num}个标签" }, { num: 1 })
            : t(
                { defaultMessage: "已选择{num}个门店" },
                { num: checkedGroups.length || 1 }
              )}
          :
        </Typography>
        <Typography variant="body1" component="div">
          {tagId
            ? currentTag.name
            : checkedGroups.length
            ? checkedGroups.map(group => group.name).join("、")
            : currentGroup.name}
        </Typography>
      </div>
      <div className={classes.item}>
        <Typography variant="body1" className={classes.label}>
          {t({ defaultMessage: "已选择{num}台设备" }, { num: devices.length })}:
        </Typography>
        <Typography variant="body1" component="div">
          {Object.keys(groupedDevices).map(status => (
            <SimpleStatusChip
              key={status}
              size="small"
              className={classes.statusChip}
              color={status === "online" ? "primary" : "default"}
              statusLabel={status}
              suffix={
                <span style={{ marginLeft: 5 }}>
                  {groupedDevices[status].length}
                </span>
              }
            />
          ))}
        </Typography>
      </div>
      <div className={classes.content}>
        {open && (
          <DeviceControls
            devices={devices}
            crossSelect={crossSelect}
            tagId={tagId}
            groupId={groupIds}
            onSetAlarm={onSetAlarm}
            onSetSchedule={onSetSchedule}
          />
        )}
      </div>
    </Modal>
  );
}

export default MemoedHOC(SendCommandModal);
